<template>
  <div class="button-block" :class="computedClass">
    <slot></slot>
  </div>
</template>

<style scoped>
.button-block.app-button-block-center {
  text-align: center;
}
.button-block.app-button-block-left {
  text-align: left;
}
.button-block.app-button-block-right {
  text-align: right;
}
.button-block button {
  padding-left: 50px;
  padding-right: 50px;
}
.button-block {
  margin-bottom: 20px;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppButtonBlock extends AppComponent {
  @Prop({require: false, default: 'left'})
  align;

  get computedClass () {
    if (this.align === 'right') {
      return ['app-button-block-right'];
    } else if (this.align === 'left') {
      return ['app-button-block-left'];
    } else if (this.align === 'center') {
      return ['app-button-block-center'];
    } else {
      return [];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppButtonBlock.vue